<template>
  <div>
    <div ref="stack-lu__title" class="h5 font-weight-bold">Select Micro-Credentials</div>
    <div class="mb-4">At least 3 published micro-credentials are required to publish a stack.</div>
    <v-select
      ref="stack-lu__v-select"
      v-model="selectorSelectedLu"
      class="style-custom"
      :class="{
        input_error: isInvalid
      }"
      multiple
      placeholder="Search Micro-credentials"
      label="name"
      :reduce="({ id, name }) => ({ id, name })"
      :loading="isLoading"
      :options="displayLuOption"
      :filterable="false"
      :searchable="false"
      :no-drop="true"
      :disabled="disabled"
      @click="onClick"
      @search="searchLu"
      @option:deselecting="onDeselected"
      ><template #list-header>
        <li style="text-align: center">Top of the list!</li>
      </template>
      <template #footer>
        <b-dropdown
          ref="lu-dropdown"
          toggle-class="custom-toggle"
          class="base__select-stack-lu"
          block
          menu-class="w-100 lu-option__dropdown"
        >
          <b-dropdown-form>
            <SearchBar
              ref="search-lu-input"
              v-model="searchKeyWords"
              class="input__search-lu p-2"
              placeholder="Search"
              hide-icon-search
              on-change-mode
              @reset="onSearchReset"
            />
          </b-dropdown-form>
          <b-dropdown-group class="lu-option-group">
            <div v-if="isLoading" key="loading" class="d-flex justify-content-center p-4 m-3">
              <b-spinner label="Loading..." variant="dark" />
            </div>
            <div v-else>
              <b-dropdown-item
                v-for="luOption in displayLuOption"
                :id="`lu-${luOption.id}`"
                :key="luOption.id"
                ref="lu-dropdown-item"
                class="lu-option__dropdown-item d-flex"
                :class="{
                  'is-selected': isSelected(luOption.id)
                }"
                @click.prevent.stop="onSelected(luOption)"
              >
                <div class="lu-option__name w-100">{{ luOption.name }}</div>
                <div v-show="isSelected(luOption.id)" class="selected-label">
                  Selected
                </div></b-dropdown-item
              >
              <b-dropdown-item v-if="!displayLuOption.length" disabled
                >No results found</b-dropdown-item
              >
            </div>
          </b-dropdown-group>
        </b-dropdown>
      </template>
    </v-select>

    <div v-if="errorRequired" ref="stack-lu__invalid-feedback" class="text_feedback">
      Please select micro-credentials.
    </div>

    <ul v-if="selectedLu.length" class="list-unstyled learning-unit-list mt-4">
      <li v-for="(learningUnit, index) in selectedLu" :key="index" class="learning-unit-item">
        <span class="learning-unit__name">
          {{ `${index + 1}. ${learningUnit.name}` }}
          <b-badge class="lu-status" :class="learningUnit.status" pill>
            <p class="p-text">{{ statusTitle(learningUnit.status) }}</p>
          </b-badge>
        </span>

        <span class="button__remove" @click="onDeselected(learningUnit)">
          <font-awesome-icon icon="times" class="text-danger" />
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';

import SearchBar from '@/views/LearningUnit/components/SearchBar.vue';

import LearningUnit from '@/models/LearningUnit';

export default {
  components: {
    SearchBar
  },

  model: {
    prop: 'vModel',
    event: 'change'
  },

  props: {
    vModel: {
      type: Array,
      default: () => []
    },
    sectorId: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isHiding: false,
      isLoading: false,
      noDrop: true,
      searchKeyWords: [],

      lu: []
    };
  },

  validations() {
    return {
      selectedLu: {
        required,
        minLength: minLength(3)
      }
    };
  },

  computed: {
    selectorSelectedLu: {
      get() {
        // if (this.selectedLu.length <= 3) {
        //   return this.selectedLu;
        // }

        // const firstThree = this.selectedLu.slice(0, 3);
        // const remainingCount = this.selectedLu.length - 3;

        // // Return first three items plus the count item only if there are remaining items
        // return remainingCount > 0
        //   ? [
        //       ...firstThree,
        //       {
        //         id: 0,
        //         name: `and ${remainingCount} more`
        //       }
        //     ]
        //   : firstThree;
        return this.selectedLu;
      },

      set(v) {
        this.addLu(v);
      }
    },
    selectedLu: {
      get() {
        return this.vModel;
      },
      set(v) {
        this.$emit('change', v);
      }
    },

    displayLuOption() {
      let searchResult = this.lu.filter((option) =>
        this.searchKeyWords.every((sk) => option.name.toLowerCase().match(sk.toLowerCase()))
      );
      return [...searchResult];
    },

    errorRequired() {
      return !this.$v.selectedLu.required && this.$v.selectedLu.$anyError;
    }
  },

  async mounted() {
    this.fetchLearningUnit();
    this.$nextTick(() => {
      this.$refs['stack-lu__v-select'].$el.addEventListener('click', this.onClick);
    });
  },

  methods: {
    statusTitle(status) {
      if (status === 'published') {
        return 'Published';
      } else if (status === 'sub-for-publication') {
        return 'Submitted for publication';
      } else {
        return 'Draft';
      }
    },
    isSelected(id) {
      return this.selectedLu.findIndex((lu) => lu.id === id) !== -1;
    },
    addLu(value) {
      if (!value.name) {
        return;
      }

      if (this.selectorSelectedLu.findIndex((lu) => lu.id === value.id) !== -1) {
        return;
      }
      if (this.selectedLu.findIndex((lu) => lu.id === value.id) !== -1) {
        return;
      }

      this.selectedLu = [
        ...this.selectedLu,
        {
          id: value.id,
          name: value.name,
          status: value.status
        }
      ];
    },
    onDeselected(value) {
      this.selectedLu = this.selectedLu.filter((item) => item.id !== value.id);
    },
    onSelected(value) {
      this.addLu(value);
      return;
    },
    syncLuForm() {
      this.selectedLu = this.selectedLu.map((selected) => {
        const matchingLu = this.lu.find((luItem) => luItem.id === selected.id);
        return {
          ...selected,
          status: matchingLu ? matchingLu.status : 'draft'
        };
      });
    },
    async fetchLearningUnit() {
      try {
        const params = {
          fields: ['id', 'name', 'is_published', 'submitted_review_at', 'required_review']
        };
        const data = await LearningUnit.api().findAll(params);

        this.lu = data.map((lu) => ({
          id: lu.id,
          name: lu.name,
          status: this.determineStatus(lu)
        }));
        this.syncLuForm();
      } catch (error) {
        console.error(error);
      }
    },
    determineStatus(lu) {
      let status = 'draft';

      switch (true) {
        case lu.is_published:
          status = 'published';
          break;
        case lu.submitted_review_at && !lu.is_published && lu.required_review:
          status = 'sub-for-publication';
          break;
      }

      return status;
    },
    onClick(e) {
      if (
        e.target.tagName === 'path' ||
        e.target.tagName === 'svg' ||
        e.target.tagName === 'SPAN'
      ) {
        return;
      }

      if (this.disabled) return;

      this.$refs['lu-dropdown'].show();
    },
    onSearchReset() {
      this.searchKeyWords = [];
    },

    async searchLu(key = '') {
      this.searchKeyWords = key.split(' ');
    }
  }
};
</script>

<style lang="scss">
.style-custom {
  .v-select {
    width: -webkit-fill-available;
  }
  .vs__selected-options {
    padding: 8.48px 20.8px;
  }

  .vs__selected {
    padding: 4px 16px;
    background-color: #eceef7;
    color: var(--primary);
    margin: 4px 4px 0px 2px;
    z-index: 1;
    border: 0;
    cursor: default;
  }

  .vs__deselect {
    fill: var(--primary);
    margin-left: 10px;
    cursor: pointer;
  }

  .vs__actions {
    display: none;
  }

  .vs__search::placeholder {
    color: rgba(7, 9, 25, 0.5);
  }
}

.input_error {
  .vs__dropdown-toggle {
    border: 1px solid #f83245;
  }
}

.text_feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f83245;
}

.custom-toggle {
  width: 100%;
  height: 100%;
  visibility: hidden;
}
.dropdown.b-dropdown.base__select-stack-lu {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 1px;
  cursor: pointer;
}
li.lu-option-group ul {
  max-height: 280px;
  overflow-y: scroll;
}

.lu-option__dropdown-item.is-selected {
  a.dropdown-item {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    background-color: #f5f5f7;
    color: #7a7b97;
  }
}

.selected-label {
  font-weight: 700;
  font-size: 14px;
}

.lu-option__name,
.learning-unit__name,
.vs__selected {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.text_feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f83245;
}

.proficiency_item {
  .error__input {
    border: 1px solid #f83245;
  }

  .error__dropdown {
    button {
      border: 2px solid #f83245;
    }
  }
}
.learning-unit-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 8px;
  gap: 10px;

  .button__remove {
    cursor: pointer;
  }
}

.lu-status.draft {
  background-color: #7a7b971a;
  .p-text {
    font-size: 12px;
    color: var(--primary-dark);
    font-weight: 700;
  }
}

.lu-status.published {
  background-color: #1bc9431a;
  .p-text {
    font-size: 12px;
    color: var(--success);
    font-weight: 700;
  }
}
.lu-status.sub-for-publication {
  background-color: #fffbf2;
  .p-text {
    font-size: 12px;
    color: var(--warning);
    font-weight: 700;
  }
}
.d-line {
  margin-top: 16px;
  gap: 10px;
  border-bottom: 1px solid #d1d2db;
}
</style>
